import { Avatar, Box, IconButton } from "@mui/material";
import React from "react";

interface UserAvatarProps {
  firstName: string;
  lastName: string;
  organizationLogo?: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  id?: string;
}

function stringToColor(string: string) {
  let hash = 0;
  for (let i = 0; i < string?.length; i += 1) {
    hash = string?.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 9)) & 0xff;
    color += `00${value?.toString(12)}`.slice(-2);
  }
  return color;
}

function stringAvatar(name: string | null | undefined) {
  if (!name) {
    return {
      sx: { bgcolor: "#ccc", width: 35, height: 35, fontSize: 15 },
      children: "?",
    };
  }
  const nameParts = name.split(" ");
  const firstInitial = nameParts[0]?.[0]?.toUpperCase() || "";
  const secondInitial = nameParts.length > 1 ? nameParts[1]?.[0]?.toUpperCase() || "" : "";
  return {
    sx: { bgcolor: stringToColor(name), width: 35, height: 35, fontSize: 15 },
    children: `${firstInitial}${secondInitial || ""}`,
  };
}

export const UserAvatar: React.FC<UserAvatarProps> = React.memo(({ 
  firstName, 
  lastName, 
  organizationLogo, 
  onClick, 
  id 
}) => {
  const fullName = `${firstName} ${lastName}`;
  
  if (organizationLogo) {
    return (
      <Box 
        className="logo_grid" 
        sx={{ 
          display: "flex", 
          alignItems: "center", 
          backgroundColor: "white", 
          cursor: "pointer"
        }}
        onClick={onClick}
      >
        <Box sx={{ paddingRight: "8px", display: { xs: "none", sm: "flex" }, alignItems: "center" }}>
          <img src={organizationLogo} alt="Organization Logo" className="logo_image" />
        </Box>
        <Box sx={{ p: 0, padding: "5px 0px", paddingLeft: "0px !important", paddingRight: "8px" }}>
          <Avatar {...stringAvatar(fullName)} />
        </Box>
      </Box>
    );
  }
  
  return (
    <IconButton
      size="small"
      aria-describedby={id}
      onClick={onClick}
      sx={{ p: 0, paddingLeft: "0px !important" }}
    >
      <Avatar {...stringAvatar(fullName)} />
    </IconButton>
  );
});

UserAvatar.displayName = "UserAvatar";
